import {t} from '@lingui/core/macro';
import {createAsyncThunk} from '@reduxjs/toolkit';

import {ApiUrls} from 'shared/config/model/urls';
import createHttpRequest from 'shared/api/http';
import {setTokens} from 'shared/api/auth';

import {fetchMe} from './fetchMe';

export const oauthFinish = createAsyncThunk<
    void,
    { provider: string; code: string; state: string, timezone: string, device_id?: string }
>(
    'auth/oauthFinish',
    // eslint-disable-next-line camelcase
    async({ provider, code, state, timezone, device_id }, { dispatch }) => {
        const response = await createHttpRequest({
            method: 'POST',
            path: ApiUrls.OAUTH_FINISH(provider),
            // eslint-disable-next-line camelcase
            data: { code, state, timezone, ...(device_id ? { device_id } : {}) },
            isAnonymous: true,
            errorMessage: t`Ошибка завершения OAuth авторизации`,
        });

        setTokens(response.data);

        await dispatch(fetchMe());
    },
);
